import React, { PropTypes, Component } from 'react'
import styles from './styles'
import TimeSheetControl from './control'
import TimehSheetCell from './cell'
import misc from 'utils/misc'
import classNames from 'classnames'
import ReviewTable from './reviewTable'
import PrintTable from './printTable'
import PrintTraffic from './printTraffic'

export default class TimeSheet extends Component {
  static propTypes = {
    rawData: PropTypes.object,
    onRecordUpdate: PropTypes.func,
    onShowChange: PropTypes.func,
    onWeekChange: PropTypes.func,
    onImportLastWeek: PropTypes.func,
    onWeekReportChange: PropTypes.func,
    onContentCodeChange: PropTypes.func,
    withControl: PropTypes.bool,
    reviewMode: PropTypes.bool,
  };

  constructor (props, context) {
    super(props, context)
  }

  state = {
    printMode: false,
  };

  getDayColIndex (weekDay) {
    return `${TimeSheet.ColType.day} ${weekDay}`
  }

  getIndexInfo (index) {
    return index.split(' ')
  }

  getRowIndex (pid, tid) {
    return `${TimeSheet.RowType.record} ${pid} ${tid}`
  }

  genColIndexes () {
    return [
      TimeSheet.ColType.header,
      TimeSheet.ColType.header,
      this.getDayColIndex(1),
      this.getDayColIndex(2),
      this.getDayColIndex(3),
      this.getDayColIndex(4),
      this.getDayColIndex(5),
      this.getDayColIndex(6),
      this.getDayColIndex(0),
      TimeSheet.ColType.summary,
    ]
  }

  genEmptyCellPropsArray (rowIndexes, colIndexes) {
    // create empty cells 2D array
    const cells = []
    for (let r = 0; r < rowIndexes.length; r++) {
      const row = []
      for (let c = 0; c < colIndexes.length; c++) {
        row.push({})
      }
      cells.push(row)
    }

    return cells
  }

  fillCellPropsWithNamesAndTypes (
    cells, rowIndexes, colIndexes, rawData, onRecordUpdate, allNotes, tShow) {
    const {
      thisMonday,
      projects,
      tasks,
    } = rawData
    const columnHeader = ['專案名稱', '內容代碼', '一', '二', '三', '四', '五', '六', '日', '一週統計']
    const rowSummaryName = '專案統計'

    const { ColType, RowType } = TimeSheet
    const CellType = TimehSheetCell.Type

    // fill array with nameMap
    cells.forEach((row, r) => row.map((oldCell, c) => {
      const rowInfo = this.getIndexInfo(rowIndexes[r])
      const rowType = rowInfo[0]
      const colInfo = this.getIndexInfo(colIndexes[c])
      const colType = colInfo[0]
      const cell = oldCell
      cell.key = `${rowIndexes[r]} ${colIndexes[c]} ${thisMonday.month} ${thisMonday.day}`
      cell.data = { r, c, rowType, colType, thisMonday }
      cell.readOnly = this.props.reviewMode

      if (rowType === RowType.header) {
        cell.type = CellType.text
        cell.data.text = columnHeader[c]
        cell.className = styles.headerRow
        // add the date to 一 ~ 日
        if (c >= 2 && c <= 8) {
          const weekDay = c - 1
          const monthDayString = misc.getMonthString(thisMonday, weekDay)
          cell.data.text = `${monthDayString}(${columnHeader[c]})`
        }
      } else if (colType === ColType.header) {
        cell.type = CellType.text
        let pid
        let tid
        switch (rowType) {
          case RowType.record:
            pid = rowInfo[1]
            tid = rowInfo[2]
            if (c === 0) {
              cell.data.text = misc.getName(projects, pid)
            } else {
              // Todo autocomplete
              cell.data.text = misc.getName(tasks, tid)
              const autoCompleteItems = []
              const curShowItemIds = tShow[pid]
              tasks.forEach(task => {
                if (task._id === tid ||
                    (!(curShowItemIds.indexOf(task._id) >= 0) && task.isEnabled)
                   ) {
                  autoCompleteItems.push(task.name)
                }
              })
              cell.data.items = autoCompleteItems
              cell.data.pid = pid
              cell.data.tid = tid
              cell.data.tasks = tasks
              cell.data.onContentCodeChange = this.props.onContentCodeChange
            }
            cell.className = styles.taskRow
            break
          case RowType.summary:
            if (c === 0) {
              cell.data.text = rowSummaryName
            }
            cell.className = styles.summaryRow
            break
          default:
            console.log('又有 bug 啦~')
        }
      } else {
        cell.type = CellType.record
        cell.data.nTime = 0
        cell.data.oTime = 0
        cell.data.note = null
        if (rowType === RowType.record) {
          cell.onRecordUpdate = onRecordUpdate
          cell.userId = rawData.userId
          cell.projectId = rowInfo[1]
          cell.taskId = rowInfo[2]
          cell.weekDay = (c - 1) % 7
          cell.dateString = misc.getDateString(thisMonday, cell.weekDay)
          cell.oSegments = []
          cell.tSegments = []
          cell.data.allNotes = allNotes
        }
      }
      return cell
    }))
  }

  fillCellPropsWithRecords (cellProps, rowIndexes, colIndexes, records) {
    const { RowType } = TimeSheet

    // for passing airbnb-eslint check
    const cells = cellProps
    const summaryColIdx = colIndexes.length - 1

    // fill cellProps with records
    const summaryRowIdx = rowIndexes.indexOf(RowType.summary)
    records.forEach(record => {
      const { projectId, taskId, nTime, oSegments = [], tSegments = [], note } = record
      const oTime = misc.getOTime(record)
      const weekDay = misc.getWeekDay(record)

      const r = rowIndexes.indexOf(this.getRowIndex(projectId, taskId))
      const c = colIndexes.indexOf(this.getDayColIndex(weekDay))

      // for this cell
      cells[r][c].data.nTime = nTime
      cells[r][c].data.oTime = oTime
      cells[r][c].data.oSegments = misc.deepCopy(oSegments)
      cells[r][c].data.tSegments = misc.deepCopy(tSegments)
      cells[r][c].data.note = note

      // for summary cell
      cells[summaryRowIdx][c].data.nTime += nTime
      cells[summaryRowIdx][c].data.oTime += oTime
      cells[r][summaryColIdx].data.nTime += nTime
      cells[r][summaryColIdx].data.oTime += oTime
      cells[summaryRowIdx][summaryColIdx].data.nTime += nTime
      cells[summaryRowIdx][summaryColIdx].data.oTime += oTime
    })
  }

  genRowIndexesAndShow (projectShow, taskShow, records) {
    const RowType = TimeSheet.RowType
    const pShow = misc.deepCopy(projectShow)
    const tShow = misc.deepCopy(taskShow)
    records.map(record => {
      const { projectId, taskId } = record

      if (!pShow.includes(record.projectId)) {
        pShow.push(record.projectId)
      }

      if (!tShow.hasOwnProperty(projectId)) {
        tShow[projectId] = []
      }

      if (!tShow[projectId].includes(taskId)) {
        tShow[projectId].push(taskId)
      }
    })

    // sort according to pid and tid
    pShow.sort()
    pShow.map(pid => {
      if (tShow[pid]) {
        tShow[pid].sort()
      } else {
        tShow[pid] = []
      }
    })

    const rowIndexes = [`${RowType.header}`]
    pShow.map(pid => {
      tShow[pid].map(tid => {
        rowIndexes.push(this.getRowIndex(pid, tid))
      }) })
    rowIndexes.push(`${RowType.summary}`)

    return { pShow, tShow, rowIndexes }
  }

  static ColType = {
    header: 'headerCol',
    day: 'dayCol',
    summary: 'summaryCol',
  };

  static RowType = {
    header: 'headerRow',
    record: 'recordRow',
    summary: 'summaryRow',
  };

  render () {
    const {
      rawData,
      onRecordUpdate,
      onShowChange,
      onWeekChange,
      onImportLastWeek,
      onWeekReportChange,
      withControl,
      reviewMode,
    } = this.props

    // now try to convert sparse rawData record array to a 2D dense array for objects
    const {
      userId,
      thisMonday,
      me,
      records,
      users,
      projects,
      tasks,
      dates,
      weekReport,
      projectShow,
      taskShow,
    } = rawData

    const allNotes = misc.genAllNotes(records)

    // Step 1: build the rowIndexes and colIndexes
    const colIndexes = this.genColIndexes()
    const { pShow, tShow, rowIndexes } = this.genRowIndexesAndShow(projectShow, taskShow, records)

    // Step 2: fill the 2D cellProps array  by records and nameMap like
    const cellProps = this.genEmptyCellPropsArray(rowIndexes, colIndexes)
    this.fillCellPropsWithNamesAndTypes(
      cellProps, rowIndexes, colIndexes, rawData, onRecordUpdate, allNotes, tShow)
    this.fillCellPropsWithRecords(cellProps, rowIndexes, colIndexes, records)

    // Step 3: Render Timesheet with 2D cellProps array
    const timesheetColumns = []

    const weekdays = {}
    for (let wd = 0; wd < 7; wd++) {
      weekdays[misc.getDateString(thisMonday, wd)] = wd
    }
    const specialDates = {}
    dates.forEach(d => {
      if (weekdays[d.date] !== undefined) {
        specialDates[weekdays[d.date]] = d
      }
    })
    for (let c = 0; c < colIndexes.length; c++) {
      const colType = this.getIndexInfo(colIndexes[c])[0]
      const isProjectCol = c === 0
      const wd = (c - 1) % 7
      let isHoliday = wd === 6 || wd === 0 // Sat & Sun
      const specialDate = specialDates[wd]
      let specialComment = null
      if (specialDate) {
        isHoliday = !(specialDate.isWorking === 'true' || specialDate.isWorking === true)
        specialComment = <div className={styles.specialComment}>{specialDate.name}</div>
      }

      const className = classNames(
                          styles.timesheetCol,
                          styles[colType],
                          { [styles.wideHeader]: isProjectCol,
                            [styles.holiday]: isHoliday,
                          })
      const columnProps = { className }

      const columnCells = []
      if (specialComment) {
        columnCells.push(specialComment)
      }
      for (let r = 0; r < rowIndexes.length; r++) {
        columnCells.push(React.createElement(TimehSheetCell, cellProps[r][c]))
      }
      timesheetColumns.push(React.createElement('div', columnProps, ...columnCells))
    }

    const timesheetClassName = classNames(
      styles.timesheet,
      { [styles.reviewMode]: reviewMode }
    )

    const showReportButton = records.length > 0

    // convert 2D data object Array to a UI table
    return (
      <div
        id="timesheetPrint"
        style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}
      >
        <h2 style={{ marginBottom: '1em' }} >
          {misc.getName(users, userId)}的工時表
        </h2>
        {withControl ?
          <TimeSheetControl
            projects={projects}
            tasks={tasks}
            weekReport={weekReport}
            projectShow={pShow}
            taskShow={tShow}
            thisMonday={thisMonday}
            onShowChange={onShowChange}
            onWeekChange={onWeekChange}
            onImportLastWeek={onImportLastWeek}
            onWeekReportChange={onWeekReportChange}
            showReportButton={showReportButton}
            reviewMode={reviewMode}
          /> : null}
        {reviewMode ?
          <ReviewTable
            {...{ me, users, projects, weekReport, onWeekReportChange, withControl }}
          /> : null}
        {React.createElement('div', { className: timesheetClassName }, ...timesheetColumns)}
        {withControl ?
        <PrintTable {...{ thisMonday, records, projects, tasks }} /> : null}
        {withControl ?
        <PrintTraffic {...{ thisMonday, records, projects, tasks }}/> : null}
        <div style={{ marginBottom: '7em' }} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/timesheet/index.jsx